// FunctionDeleteConfirmationModal.tsx
import React from 'react';
import './FunctionsManagement.css';

interface FunctionDeleteConfirmationModalProps {
  isOpen: boolean;
  functionName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const FunctionDeleteConfirmationModal: React.FC<FunctionDeleteConfirmationModalProps> = ({
  isOpen,
  functionName,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-container">
        <div className="delete-modal-content">
          <h2 className="delete-modal-title">Delete Division</h2>
          <p className="delete-modal-message">
            Are you sure you want to delete "<span className="function-name-highlight">{functionName}</span>"?
          </p>
          <div className="delete-modal-actions">
            <button
              onClick={onConfirm}
              className="btn-confirm-delete"
              type="button"
            >
              Delete
            </button>
            <button
              onClick={onCancel}
              className="btn-cancel-delete"
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};